import { WAITING } from './types';

const waiting = () => (dispatch: WtrDispatch) => dispatch({ type: WAITING });

export default waiting;
